import { render } from "./ContactRolesPanel.vue?vue&type=template&id=4895f01b"
import script from "./ContactRolesPanel.vue?vue&type=script&lang=js"
export * from "./ContactRolesPanel.vue?vue&type=script&lang=js"
script.render = render

export default script